export default {
    guider: {
        title: '現在これらのヘルプが必要ですか：',
        more: 'ヘルプセンターにアクセスし、効率アップスキールを身につけましょう！',
    },
};
